import { Component, Host, h, Prop, State, Watch } from '@stencil/core';
// import { relativeTimeThreshold } from 'moment';
import '../header-component/header-component'
import '../loader-component/loader-component'
import queryString from 'query-string'
// import moment from 'moment';
import { DateTime } from "luxon";

const parsedValues = queryString.parse(window.location.search.toLowerCase());
let itemid: any = ""
let listname: any = "Announcements"
let webpath: any = ""
let infonetid: any = ""
if (parsedValues != null) {

  console.log("Item Id:" + parsedValues.newsid)
  console.log("list Name:" + parsedValues.listname)
  if (parsedValues.listname) {
    listname = parsedValues.listname
  }
  if (parsedValues.webpath) {
    webpath = parsedValues.webpath
  }

  itemid = parsedValues.newsid
 
  window.document.title = "Announcement"
  infonetid = parsedValues.infonetid

}


/**
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/newsitem-component.PNG)

#### Content Type
nypwebc_ct_announcements

Query strings
listname
newsid
webpath

Example -  https://infonet.nyp.org/webc/Pages/NewsItem.aspx?listname=webc_announcements&webpath=/webc&newsid=1

*/



@Component({
  tag: 'homeannouncementitem-component',
  styleUrl: 'homeannouncementitem-component.css',
  scoped: true
})




export class HomeannouncementitemComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";


  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
    *Optional - To show/hide header - default is true
    */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
  *Optional -include image to the body
  */
  @Prop() includeimage: boolean = true

  @State() isLoading: boolean = true
  @State() items: any = {}

  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl 
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin 
    }

    let restUrl=""
    
    if(itemid) {
       restUrl= siteUrl + webpath + "/_api/web/lists/getbytitle('" + listname + "')/items('" + itemid + "')?$select=ID,Title,Body,LinkToResource,LinkToResource2,NewsDescription,ThumbnailImage,StartDate"
    } 
    else if (infonetid)
      {
        restUrl = siteUrl + webpath + "/_api/web/lists/getbytitle('" + listname + "')/items?$select=ID,Title,Body,LinkToResource,LinkToResource2,NewsDescription,ThumbnailImage,StartDate&$top=1&$filter=InfonetNewsId eq " + infonetid
      }
    
    return fetch(restUrl, { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d;
        this.isLoading = false;
      });
  }

  getContents = () => {

    const contentsArray = []

    let body=""
    let startdate=""
    let title=""
    let id=""

    if (itemid)
    {
      body=this.items.Body;
      startdate=this.items.StartDate
      title=this.items.Title
      id=this.items.ID
    }
    else if (infonetid) {
      body=this.items.results[0].Body;
      startdate=this.items.results[0].StartDate
      title=this.items.results[0].Title
      id=this.items.results[0].ID
    }
    var string = body
    var parser = new DOMParser();
    var domNode = parser.parseFromString(string, "text/html");
    const img = domNode.querySelectorAll("img");

    for (let i = 0; i < img.length; i++) {
      img[i].classList.add("sc-homeannouncementitem-component", "img-fluid", "rounded");
    }

     let postedDate = DateTime.fromISO(startdate).toLocaleString(DateTime.DATE_SHORT)
    contentsArray.push(
      <div class="prose" key={id} >
        <p style={{ marginLeft: "20px", marginTop: "10px" }}> Posted {postedDate} </p>
        <h2 style={{ fontSize: "25px", marginLeft: "20px", marginTop: "20px" ,color:"#2e343c"}}> {title} </h2>
        <p > <div class="news-body" style={{paddingLeft:"20px"}} innerHTML={domNode.body.innerHTML} /> </p>
        <div></div>
      </div>
    )

    return contentsArray
  }

  render() {
    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        padding: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        padding: "10px"
      }
    }


    return (
      this.isLoading ?
        <loader-component /> :
        this.header && this.items ?
          <div >
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>
                {this.getContents()}
              </div>
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle} >
            <div style={style}>
              {this.getContents()}
            </div>
          </div>

    )


  }

}

